import { createAction } from "@reduxjs/toolkit";
import {
  clearChangeEmailStatesActionType,
  updateEmailActionTypes,
} from "./actionTypes";

export const updateEmail = createAction(updateEmailActionTypes.request);

export const updateEmailSuccess = createAction(
  updateEmailActionTypes.success,
  (payload) => ({ payload }),
);

export const updateEmailFailure = createAction(
  updateEmailActionTypes.failure,
  (error) => ({ payload: error }),
);

export const clearChangeEmailStates = createAction(
  clearChangeEmailStatesActionType,
);
